import { SlCalculator } from "react-icons/sl";

const TaxManagement = () => {
  return <SlCalculator size={23} className="sidebar-icon" />;
};

export default TaxManagement;
